module.exports = __webpack_public_path__ + "static/img/Htitb.9f9be30.png";